import { BaseApi } from './base.api.js';
import { ApiError } from '../errors/api-error.js';

export class MatrixConfigurationApi extends BaseApi {
    constructor(client) {
        super(client, '/matrix-configuration');
    }

    async getMatrixConfiguration() {
        try {
            const response = await this.client.get(this.basePath);
            return response.data || response;
        } catch (error) {
            throw ApiError.fromResponse(error);
        }
    }

    async updateMatrixConfiguration(data) {
        try {
            const response = await this.client.put(this.basePath, data);
            return response.data || response;
        } catch (error) {
            throw ApiError.fromResponse(error);
        }
    }
}
